import React, { useCallback, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

import IsGranted from '../../../components/is-granted/IsGranted';
import { PROJECT_TYPES, USER_ROLES } from '../../../constants';
import HeaderColumn from '../header-column/HeaderColumn';
import SonarCommonHeader from '../sonar-common/SonarCommonHeader';
import HeaderLabel from '../header-label/HeaderLabel';
import HeaderAddButton from '../header-add-button/HeaderAddButton';

const ProjectsHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('header');
  const editProject = useSelector((state) => state.projects.editProject);

  const handleCreateProject = useCallback(() => {
    navigate('/projects/create');
  }, [navigate]);

  return (
    <HeaderColumn>
      <Routes>
        <Route
          path='/'
          element={
            <HeaderAddButton
              label={t('projects')}
              onClick={handleCreateProject}
              permissions={USER_ROLES.GLOBAL_ADMIN}
            />
          }
        />
        <Route
          path='/create'
          element={
            <IsGranted permissions={USER_ROLES.GLOBAL_ADMIN}>
              <HeaderLabel>{t('createNewProject')}</HeaderLabel>
            </IsGranted>
          }
        />
        {CREATE_PROJECTS.map(({ path, projectTypeLabel }) => (
          <Route
            key={path}
            path={path}
            element={
              <IsGranted permissions={USER_ROLES.GLOBAL_ADMIN}>
                <HeaderLabel>{t('createTypeProject', { projectType: projectTypeLabel })}</HeaderLabel>
              </IsGranted>
            }
          />
        ))}
        {COMMON_EDIT_PAGES.map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <IsGranted permissions={USER_ROLES.GLOBAL_ADMIN}>
                <HeaderLabel>
                  {t('edit')} {editProject?.projectName}
                </HeaderLabel>
              </IsGranted>
            }
          />
        ))}
        <Route path={`/edit/${PROJECT_TYPES.SONAR}/:id`} element={<SonarCommonHeader />} />
      </Routes>
    </HeaderColumn>
  );
};

export default memo(ProjectsHeader);

const CREATE_PROJECTS = [
  {
    path: '/create/sonar',
    projectTypeLabel: 'Sonar',
  },
  {
    path: '/create/resonance',
    projectTypeLabel: 'Resonance',
  },
  {
    path: '/create/scout',
    projectTypeLabel: 'Scout',
  },
  {
    path: '/create/genie',
    projectTypeLabel: 'Genie',
  },
  {
    path: '/create/genie-go',
    projectTypeLabel: 'GenieGo',
  },
  {
    path: '/create/id8',
    projectTypeLabel: 'ID8',
  },
  {
    path: '/create/activ8',
    projectTypeLabel: 'ACTIV8',
  },
];

const COMMON_EDIT_PAGES = [
  `/edit/${PROJECT_TYPES.RESONANCE}/:id`,
  `/edit/${PROJECT_TYPES.SCOUTV2}/:id`,
  `/edit/${PROJECT_TYPES.GENIE}/:id`,
  `/edit/${PROJECT_TYPES.GENIE}/:id`,
  `/edit/${PROJECT_TYPES.ID8}/:id`,
  `/edit/${PROJECT_TYPES.ACTIV8}/:id`,
  `/edit/genie-go/:id`,
];
